let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { Group, tokens } from '@klarna/ui';
import KovfsWarning from 'features/installments/components/kovfsWarning/KovfsWarning';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { useTranslate } from 'framework/utils/i18n/useTranslate';
const InstallmentDisclaimer = ({ translationKey, kovfsWarningPaddingHorizontal })=>{
    const translate = useTranslate();
    if (!translationKey) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Group, {
        direction: "vertical",
        gap: "space/16",
        children: [
            /*#__PURE__*/ _jsx(RichTextMarkdown, {
                sx: css(t || (t = _`
          max-width: 100%;

          p,
          p > *,
          a {
            font-size: ${0}px;
            line-height: ${0}px;
            color: ${0};
          }
          a:hover {
            color: ${0};
          }
        `), tokens.textSizes['text/desktop/s'], tokens.lineHeights['body/desktop/s'], tokens.colors.light['text/subtle'], tokens.colors.light['text/subtle']),
                children: translate(translationKey)
            }),
            /*#__PURE__*/ _jsx(KovfsWarning, {
                paddingHorizontal: kovfsWarningPaddingHorizontal
            })
        ]
    });
};
export default InstallmentDisclaimer;
